var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { Form } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
// import { InfoCircleFilled } from '@ant-design/icons';
import { bankCardReg, idCardReg, moneyReg, phoneReg, qqReg } from './reg';
/** 三木运算符表达式切割 */
export var ternaryOperator = function (content, form) {
    var _split = content.split(' ');
    var isExp = _split[0] === 'exp';
    if (!isExp) {
        return content;
    }
    var dependence = _split[1];
    var origin_dependence_val = _split[3];
    var origin_val = _split[5];
    var val = _split[7];
    var dependence_value = Form.useWatch(dependence, form);
    if ("".concat(dependence_value) === "".concat(origin_dependence_val)) {
        return origin_val;
    }
    return val;
};
/** props 设备转换 */
export var FormPropsDeviceOperator = function (props, isMobile) {
    var _props = {};
    var keys = _.keys(props);
    if (_.includes(keys, 'mobile') || _.includes(keys, 'pc')) {
        if (isMobile) {
            // @ts-ignore
            _props = props.mobile || {};
        }
        else {
            // @ts-ignore
            _props = props.pc || {};
        }
    }
    else {
        _props = props;
    }
    return _props;
};
/** props依赖转换 */
export var FormPropsDependenceOperator = function (props, dependencesValues) {
    var _a, _b, _c;
    var _props = {};
    // eslint-disable-next-line guard-for-in
    for (var key in props) {
        var prop = props[key];
        var keys = _.keys(prop);
        if (!_.isObject(prop)) {
            _props = __assign(__assign({}, _props), (_a = {}, _a[key] = prop, _a));
        }
        if (_.isObject(prop)) {
            if (_.includes(keys, 'relations')) {
                // @ts-ignore
                var dependence_value = dependencesValues[prop.dependence];
                // @ts-ignore
                _props = __assign(__assign({}, _props), (_b = {}, _b[key] = prop.relations[dependence_value] || '', _b));
            }
            else {
                _props = __assign(__assign({}, _props), (_c = {}, _c[key] = prop || {}, _c));
            }
        }
    }
    return _props;
};
export var formFeedbackOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '来源',
                name: 'origin',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入反馈来源'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入反馈来源如：小程序/抖音/QQ',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '账号',
                name: 'account',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入账号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-1',
                        title: '功能异常'
                    },
                    {
                        key: 'feedback-2',
                        title: '活动异常'
                    },
                    {
                        key: 'feedback-3',
                        title: '显示异常'
                    },
                    {
                        key: 'feedback-4',
                        title: '闪退卡死'
                    },
                    {
                        key: 'feedback-5',
                        title: '封禁申诉'
                    },
                    {
                        key: 'feedback-6',
                        title: '游戏建议'
                    },
                    {
                        key: 'feedback-7',
                        title: '其他问题'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formFeedbackCommonOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-1',
                        title: '功能异常'
                    },
                    {
                        key: 'feedback-2',
                        title: '活动异常'
                    },
                    {
                        key: 'feedback-3',
                        title: '显示异常'
                    },
                    {
                        key: 'feedback-4',
                        title: '闪退卡死'
                    },
                    {
                        key: 'feedback-5',
                        title: '封禁申诉'
                    },
                    {
                        key: 'feedback-6',
                        title: '游戏建议'
                    },
                    {
                        key: 'feedback-7',
                        title: '其他问题'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formReportOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '来源',
                name: 'origin',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入反馈来源'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入反馈来源如：小程序/抖音/QQ',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '违规玩家角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入违规玩家角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入违规玩家角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '违规玩家角色ID',
                name: 'role_id'
            },
            componentProps: {
                placeholder: '请尽量提供对方的角色ID，若没有请填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '违规行为',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个违规行为'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'report-1',
                        title: '言语辱骂'
                    },
                    {
                        key: 'report-2',
                        title: '名称/头像违规'
                    },
                    {
                        key: 'report-3',
                        title: '疑似开挂/脚本'
                    },
                    {
                        key: 'report-4',
                        title: '其他违规情况'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '违规描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请详细描述用户违规情况'
                    }
                ]
            },
            componentProps: {
                placeholder: '详细描述关于该用户的违规情况，若有录屏和截图可在下方补充。',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                required: true,
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formReportCommonOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '违规玩家角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入违规玩家角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入违规玩家角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '违规玩家角色ID',
                name: 'role_id'
            },
            componentProps: {
                placeholder: '请尽量提供对方的角色ID，若没有请填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '违规行为',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个违规行为'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'report-1',
                        title: '言语辱骂'
                    },
                    {
                        key: 'report-2',
                        title: '名称/头像违规'
                    },
                    {
                        key: 'report-3',
                        title: '疑似开挂/脚本'
                    },
                    {
                        key: 'report-4',
                        title: '其他违规情况'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '违规描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请详细描述用户违规情况'
                    }
                ]
            },
            componentProps: {
                placeholder: '详细描述关于该用户的违规情况，若有录屏和截图可在下方补充。',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                required: true,
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formRechargeOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '来源',
                name: 'origin',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入反馈来源'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入反馈来源如：小程序/抖音/QQ',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '账号',
                name: 'account',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入账号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'recharge-1',
                        title: '充值不到账'
                    },
                    {
                        key: 'recharge-2',
                        title: '无法充值'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formRechargeCommonOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'recharge-1',
                        title: '充值不到账'
                    },
                    {
                        key: 'recharge-2',
                        title: '无法充值'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '订单说明',
                name: 'order_mark'
            },
            componentProps: {
                placeholder: '请填写订单说明',
                maxLength: 500,
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formPlatformCommonOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'platform-1',
                        title: '首页异常'
                    },
                    {
                        key: 'platform-2',
                        title: '交流异常'
                    },
                    {
                        key: 'platform-3',
                        title: '福利异常'
                    },
                    {
                        key: 'platform-4',
                        title: '我页异常'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formGeneralCommonOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-1',
                        title: '功能异常'
                    },
                    {
                        key: 'feedback-2',
                        title: '活动异常'
                    },
                    {
                        key: 'feedback-3',
                        title: '显示异常'
                    },
                    {
                        key: 'feedback-4',
                        title: '闪退卡死'
                    },
                    {
                        key: 'feedback-5',
                        title: '封禁申诉'
                    },
                    {
                        key: 'feedback-6',
                        title: '游戏建议'
                    },
                    {
                        key: 'feedback-7',
                        title: '其他问题'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formGeneralBaseCommonOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-8',
                        title: '游戏异常'
                    },
                    {
                        key: 'feedback-9',
                        title: '登录问题'
                    },
                    {
                        key: 'feedback-10',
                        title: '违规处理'
                    },
                    {
                        key: 'feedback-11',
                        title: '攻略咨询'
                    },
                    {
                        key: 'feedback-12',
                        title: '充值相关'
                    },
                    {
                        key: 'feedback-14',
                        title: '其他相关'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formGeneral2Options = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-8',
                        title: '游戏异常'
                    },
                    {
                        key: 'feedback-9',
                        title: '登录问题'
                    },
                    {
                        key: 'feedback-10',
                        title: '违规处理'
                    },
                    {
                        key: 'feedback-11',
                        title: '攻略咨询'
                    },
                    {
                        key: 'feedback-12',
                        title: '充值相关'
                    },
                    {
                        key: 'feedback-14',
                        title: '其他相关'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'test_area'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formFeedBackSsbqOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-8',
                        title: '游戏异常'
                    },
                    {
                        key: 'feedback-9',
                        title: '登录问题'
                    },
                    {
                        key: 'feedback-15',
                        title: '封号禁言'
                    },
                    {
                        key: 'feedback-11',
                        title: '攻略咨询'
                    },
                    {
                        key: 'feedback-16',
                        title: '投诉反馈'
                    },
                    {
                        key: 'feedback-14',
                        title: '其他相关'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'test_area'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formRechargeSsbqOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色ID',
                name: 'role_id',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色ID，若没有则填“无”'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色ID，若没有则填“无”',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'recharge-1',
                        title: '充值不到账'
                    },
                    {
                        key: 'recharge-2',
                        title: '无法充值'
                    },
                    {
                        key: 'recharge-3',
                        title: '返利相关'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '订单说明',
                name: 'order_mark'
            },
            componentProps: {
                placeholder: '请填写订单说明',
                maxLength: 500,
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    },
                    {
                        key: '3',
                        title: 'QQ'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ],
                        '3': [
                            {
                                required: true,
                                message: '请输入您的QQ号'
                            },
                            {
                                pattern: qqReg,
                                message: '请输入正确的QQ号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号',
                        '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formTestOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['type'],
    formDependencesInit: {
        type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 24
                }
            },
            formProps: {
                label: '',
                name: {
                    dependence: 'type',
                    relations: {
                        '1': 'phone',
                        '2': 'email'
                    }
                },
                required: true,
                rules: {
                    dependence: 'type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入邮箱'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'type',
                    relations: {
                        '1': '请输入手机号',
                        '2': '请输入邮箱'
                    }
                }
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                layout: 'vertical',
                label: '图片',
                name: 'image'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card'
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                layout: 'vertical',
                label: '时间',
                name: 'date',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                placeholder: '请选择时间'
            },
            type: 'date_picker'
        }
    ]
};
export var formFeedbackPCOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '1'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '游戏名称',
                name: 'game_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏名称'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏名称',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '账号',
                name: 'account',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入账号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '区服',
                name: 'server',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入游戏区服'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入游戏区服',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '角色名',
                name: 'role',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入角色名'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入角色名',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题类型',
                name: 'question_type',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择一个问题类型'
                    }
                ]
            },
            componentProps: {
                options: [
                    {
                        key: 'feedback-9',
                        title: '登录问题',
                        desc: '封禁申诉、网页登录异常、微端登录异常、黑屏、白屏、无法进入游戏等'
                    },
                    {
                        key: 'feedback-19',
                        title: '活动问题',
                        desc: '线下活动申请(实体奖励)、活动奖励未获得、活动无法参加、返利申请、超级用户问题相关'
                    },
                    {
                        key: 'feedback-17',
                        title: '游戏BUG',
                        desc: '游戏内各种bug问题'
                    },
                    {
                        key: 'feedback-18',
                        title: '物品丢失',
                        desc: '物品异常丢失、误操作申请道具找回、被盗恢复'
                    },
                    {
                        key: 'feedback-7',
                        title: '其他问题',
                        desc: '未在以上内容之内'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '问题描述',
                name: 'question',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入问题描述'
                    }
                ]
            },
            componentProps: {
                placeholder: '请详细描述您遇到的bug情况，若有录屏/截图，请在下方补充',
                maxLength: 500,
                style: { resize: 'none' },
                autoSize: { minRows: 3, maxRows: 5 }
            },
            type: 'textarea'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关视频',
                name: 'video',
                extra: '（一个视频，低于500M）'
            },
            componentProps: {
                maxCount: 3,
                accept: '.mp4 ,.avi, .flv ,.asf ,.mov ,.mpeg ,.wmv ,.rm ,.rmvb, .mpg, .wav, .3gp, .m4v, .mkv'
            },
            type: 'upload_video'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files'
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10
            },
            type: 'upload_file'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '发生时间',
                name: 'time',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请选择时间'
                    }
                ]
            },
            componentProps: {
                mobile: {
                    placeholder: '请选择时间',
                    max: new Date()
                },
                pc: {
                    placeholder: '请选择时间',
                    disabledDate: function (current) { return current && current > dayjs().endOf('day'); }
                }
            },
            type: 'date_picker'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                required: true
            },
            componentProps: {
                options: [
                    {
                        key: '1',
                        title: '手机'
                    },
                    {
                        key: '2',
                        title: '邮箱'
                    }
                    // {
                    //     key: '3',
                    //     title: 'QQ'
                    // }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                span: 12
            },
            formProps: {
                label: '',
                name: 'contact',
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '1': [
                            {
                                required: true,
                                message: '请输入您的手机号'
                            },
                            {
                                pattern: phoneReg,
                                message: '请输入正确的手机号'
                            }
                        ],
                        '2': [
                            {
                                required: true,
                                message: '请输入您的邮箱号'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ]
                        // '3': [
                        //     {
                        //         required: true,
                        //         message: '请输入您的QQ号'
                        //     },
                        //     {
                        //         pattern: qqReg,
                        //         message: '请输入正确的QQ号'
                        //     }
                        // ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '1': '请输入您的手机号',
                        '2': '请输入您的邮箱号'
                        // '3': '请输入您的QQ号'
                    }
                }
            },
            type: 'input'
        }
    ]
};
export var formCheckAccountYxdOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '2'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '实名姓名',
                name: 'real_name'
            },
            componentProps: {
                placeholder: '请输入账号实名姓名',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '身份证号',
                name: 'id_card',
                rules: [
                    {
                        pattern: idCardReg,
                        message: '请输入正确的身份证号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号实名身份证号',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '手机号码',
                name: 'phone',
                rules: [
                    {
                        pattern: phoneReg,
                        message: '请输入正确的手机号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号绑定的手机号'
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '银行卡号',
                name: 'bank_card',
                rules: [
                    {
                        pattern: bankCardReg,
                        message: '请输入正确的银行卡号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号绑定的银行卡号',
                maxLength: 20
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '开户行',
                name: 'bank_name'
            },
            componentProps: {
                placeholder: '请输入银行卡开户行',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '充值金额',
                name: 'history_amount',
                rules: [
                    {
                        pattern: moneyReg,
                        message: '请输入正确的充值金额'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入账号历史充值金额',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '充值订单号',
                name: 'order_no'
            },
            componentProps: {
                placeholder: '请填写金额较大的一个',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 12,
                style: {
                    display: 'none'
                }
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                hidden: true
            },
            componentProps: {
                options: [
                    {
                        key: '2',
                        title: '邮箱'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '联系邮箱',
                name: 'contact',
                required: true,
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '2': [
                            {
                                required: true,
                                message: '请输入联系邮箱'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            }
                        ]
                    }
                }
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '2': '请输入联系邮箱'
                    }
                }
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '相关截图',
                name: 'images',
                extra: '（jpg、png、jpeg，单张小于8M）'
            },
            componentProps: {
                accept: '.jpg,.jpeg,.png',
                multiple: false,
                listType: 'picture-card',
                maxCount: 10
            },
            type: 'upload_image'
        }
    ]
};
export var formCheckRechargeYxdOptions = {
    /**
     * 配置规则
     * @formDependences 整体表单需要注入valueChange到值
     * @formDependencesInit 依赖数据的默认值
     */
    formDependences: ['contact_type'],
    formDependencesInit: {
        contact_type: '2'
    },
    /**
     * 配置规则
     * @colProps ant Design Col的props
     * @formProps ant Design Form.Item的props
     * @componentProps ant Design Components的props
     * @dependence 当某个变量为对象，且同时包含dependence以及relations时，会自动触发Form.useWatch根据relations改变props
     * @relations 与dependence必须同时存在
     * @mobile 移动端props
     * @pc PC端Props
     */
    formOptions: [
        {
            colProps: {
                span: 24
            },
            componentProps: {
                type: 'error',
                message: (React.createElement(React.Fragment, null,
                    "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8D26\u53F7\u4FE1\u606F\u8BF7\u4E0D\u8981\u8FDB\u884C\u5171\u4EAB\uFF0C\u4EFB\u4F55\u975E\u6E38\u620F\u5E97\u5B98\u7F51\uFF08",
                    React.createElement("a", { target: "_blank", href: "//www.youxidian.com", rel: "noopener noreferrer", style: { color: '#3597e3' } }, "www.youxidian.com"),
                    "\uFF09\u8FDB\u5165\u7684\u94FE\u63A5\u8BF7\u4E0D\u8981\u70B9\u51FB\u3002"))
            },
            type: 'alert'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '所出售账号',
                name: 'account_name',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入所出售的账号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入所出售的账号',
                maxLength: 50
            },
            type: 'input'
        },
        {
            colProps: {
                span: 12,
                style: {
                    display: 'none'
                }
            },
            formProps: {
                label: '联系方式',
                name: 'contact_type',
                hidden: true
            },
            componentProps: {
                options: [
                    {
                        key: '2',
                        title: '邮箱'
                    }
                ]
            },
            type: 'radio'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '联系邮箱',
                name: 'contact',
                required: true,
                rules: {
                    dependence: 'contact_type',
                    relations: {
                        '2': [
                            {
                                required: true,
                                message: '请输入联系邮箱'
                            },
                            {
                                type: 'email',
                                message: '请输入正确的邮箱号'
                            },
                            {
                                pattern: /^(?![^\s@]+@gmail\.com$).*$/i,
                                message: '暂不支持谷歌邮箱'
                            }
                        ]
                    }
                },
                extra: '建议您使用QQ邮箱，如用谷歌邮箱等会收不到信息'
            },
            componentProps: {
                placeholder: {
                    dependence: 'contact_type',
                    relations: {
                        '2': '请输入联系邮箱'
                    }
                }
            },
            type: 'input'
        },
        {
            colProps: {
                mobile: {
                    span: 24
                },
                pc: {
                    span: 12
                }
            },
            formProps: {
                label: '联系手机号码',
                name: 'phone',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请输入联系手机号码'
                    },
                    {
                        pattern: phoneReg,
                        message: '请输入正确的手机号'
                    }
                ]
            },
            componentProps: {
                placeholder: '请输入联系手机号'
            },
            type: 'input'
        },
        {
            colProps: {
                span: 24
            },
            formProps: {
                label: '附件',
                name: 'files',
                required: true,
                rules: [
                    {
                        required: true,
                        message: '请上传附件'
                    }
                ]
            },
            componentProps: {
                accept: '.txt,.doc,.docx,.xls,.xlsx,.pdf,.gif,.jpg,.png,.bmp,.mp3,.rar,.zip,.sgs,.sip,.jpeg',
                multiple: false,
                listType: 'picture',
                maxCount: 10,
                describeTextElement: (React.createElement("span", { style: { color: 'rgba(0, 0, 0, 0.45)' } },
                    "\u8BF7\u4E0B\u8F7D\u793A\u4F8B\u6A21\u677F\u586B\u5199\u5B8C\u6574\u540E\u518D\u4E0A\u4F20 \uFF08",
                    React.createElement("a", { 
                        // target="_blank"
                        href: "/chat/chat/home/im/faq-yxdAccountTemplate", rel: "noopener noreferrer", style: { color: '#3597e3' } }, "\u70B9\u51FB\u4E0B\u8F7D\u793A\u4F8B\u6A21\u677F"),
                    "\uFF09"))
            },
            type: 'upload_file'
        }
    ]
};
export var formOptions = {
    test: formTestOptions,
    feedback: formFeedbackOptions,
    report: formReportOptions,
    recharge: formRechargeOptions,
    feedback_no_refer: formFeedbackCommonOptions,
    report_no_refer: formReportCommonOptions,
    recharge_no_refer: formRechargeCommonOptions,
    platform: formPlatformCommonOptions,
    general: formGeneralCommonOptions,
    general_base: formGeneralBaseCommonOptions,
    general_2: formGeneral2Options,
    feedback_ssbq: formFeedBackSsbqOptions,
    recharge_ssbq: formRechargeSsbqOptions,
    feedback_pc: formFeedbackPCOptions,
    check_account_yxd: formCheckAccountYxdOptions,
    check_recharge_yxd: formCheckRechargeYxdOptions
};
export var FORM_CONFIG = [
    {
        key: 'feedback',
        title: '问题反馈',
        platform: ''
    },
    {
        key: 'report',
        title: '我要举报',
        platform: ''
    },
    {
        key: 'recharge',
        title: '充值问题',
        platform: ''
    },
    {
        key: 'feedback_no_refer',
        title: '游戏问题',
        platform: 'no_refer'
    },
    {
        key: 'report_no_refer',
        title: '我要举报',
        platform: 'no_refer'
    },
    {
        key: 'recharge_no_refer',
        title: '充值问题',
        platform: 'no_refer'
    },
    {
        key: 'platform',
        title: '平台问题',
        platform: 'no_refer'
    },
    {
        key: 'general',
        title: '通用问题（旧）',
        platform: 'no_refer'
    },
    {
        key: 'general_base',
        title: '通用问题（基础）',
        platform: 'no_refer'
    },
    {
        key: 'general_2',
        title: '通用问题',
        platform: 'no_refer'
    },
    {
        key: 'feedback_ssbq',
        title: '游戏问题（3387）',
        platform: 'no_refer'
    },
    {
        key: 'recharge_ssbq',
        title: '充值问题（3387）',
        platform: 'no_refer'
    },
    {
        key: 'feedback_pc',
        title: '游戏问题（PC）',
        platform: 'no_refer'
    },
    {
        key: 'check_account_yxd',
        title: '账号信息验证',
        platform: 'no_refer'
    },
    {
        key: 'check_recharge_yxd',
        title: '自助提交充值明细验证',
        platform: 'no_refer',
        successSubTitle: (React.createElement(React.Fragment, null,
            "\u660E\u7EC6\u6838\u5B9E\u7ED3\u679C\u6E38\u620F\u5E97\u5C06\u4EE5\u90AE\u4EF6",
            React.createElement("br", null),
            "\uFF08",
            React.createElement("a", { style: { cursor: 'default' } }, "gly@youxidian.com"),
            "\uFF09\u901A\u77E5\u60A8\uFF0C\u8BF7\u60A8\u8010\u5FC3\u7B49\u5F85~"))
    }
];
